import React from 'react';
import DENTModalOverviewViewOptionsIcon from './DENTModalOverviewViewOptionsIcon';
import { ViewOption } from '../../Interfaces/ViewOption.interface';
import useTranslation from '../../../../Hooks/useTranslation';
// @ts-ignore
import styles from './DENTModalOverviewViewOption.module.scss';
import { joinClasses } from '../../../../Utils/className.util';

const DENTModalOverviewViewOption = ({
	title,
	onClick,
	isActive,
}: ViewOption) => {
	const { t } = useTranslation();

	return (
		<div
			className={joinClasses([styles.wrapper, isActive ? styles.active : ''])}
			onClick={onClick}>
			<DENTModalOverviewViewOptionsIcon />
			{t(title)}
		</div>
	);
};

export default DENTModalOverviewViewOption;
